module.exports = __webpack_public_path__ + "img/layout1.fd65ae49.png";